import React from 'react';
import { SpriteSvg } from 'project/sprite-svg';

const FavoriteButton = ({ childCss, onClick, stateFavoriteButton }) => {
    const getState = () => {
        let stateFavoriteButtonClassName = '';
        if (stateFavoriteButton) {
            stateFavoriteButtonClassName = 'is-active';
        }
        return stateFavoriteButtonClassName;
    };

    return (
        <button
        className={`${childCss} favorite-button button-round button-round--base is-border-white ${getState()}`}
        onClick={onClick}
        >
            <SpriteSvg iconName="star" width="14" height="14" />
        </button>
    );
};

FavoriteButton.defaultProps = {
    childCss: '',
};

export default FavoriteButton;
